
export const TRELLO_KEY = '301d5439a4d8bd2b56c39c18139b44c5';
export const API_URL = 'https://api.trello.com/1/';
export const AUTH_URL = 'https://trello.com/1/authorize';



// WEBPACK FOOTER //
// ./src/config.js